/**
 * Builds a Firestore path based on the provided parameters
 * @param {Object} params
 * @param {string} params.profileId - Family code or profile ID
 * @param {string} [params.userId] - User ID (optional)
 * @param {string} params.collectionType - Type of collection (photos/documents)
 * @param {string} params.storageArea - Storage area (personal/family/vault)
 * @returns {string} The constructed Firestore path
 */
export const buildFirestorePath = ({ profileId, userId, collectionType, storageArea }) => {
  if (!profileId || !collectionType || !storageArea) {
    throw new Error('Missing required parameters for path construction');
  }

  switch (storageArea) {
    case 'personal':
      if (!userId) {
        throw new Error('userId is required for personal storage area');
      }
      return `users/${userId}/${collectionType}`;
    case 'family':
      return `families/${profileId}/${collectionType}`;
    case 'vault':
      return `families/${profileId}/vault/${collectionType}`;
    default:
      throw new Error(`Invalid storage area: ${storageArea}`);
  }
};

/**
 * Builds a Storage path based on the provided parameters
 * @param {Object} params
 * @param {string} params.profileId - Family code or profile ID
 * @param {string} [params.userId] - User ID (optional)
 * @param {string} params.collectionType - Type of collection (photos/documents)
 * @param {string} params.storageArea - Storage area (personal/family/vault)
 * @param {string} params.fileId - File ID
 * @returns {string} The constructed Storage path
 */
export const buildStoragePath = ({ profileId, userId, collectionType, storageArea, fileId }) => {
  if (!profileId || !collectionType || !storageArea || !fileId) {
    throw new Error('Missing required parameters for path construction');
  }

  switch (storageArea) {
    case 'personal':
      if (!userId) {
        throw new Error('userId is required for personal storage area');
      }
      return `users/${userId}/${collectionType}/${fileId}`;
    case 'family':
      return `families/${profileId}/${collectionType}/${fileId}`;
    case 'vault':
      return `families/${profileId}/vault/${collectionType}/${fileId}`;
    default:
      throw new Error(`Invalid storage area: ${storageArea}`);
  }
}; 